// var rating = require('./rating')

var choicesRight = function() {
    var string = '<div class="col-lg-3 col-md-3 choices-right">' +
        '<div class="row">' +
            '<div class="col-lg-12 col-md-12">' +
                '<div class="image-frame">' +
                '</div>' +
                '<div class="image-list row"></div>'
            '</div>' +
        '</div>' +
        // '<div class="row ratings-row"></div>' +
        '</div>';
    var right = $.parseHTML(string);
    // $(right).find('.ratings-row').append(rating());
    return right;
}

module.exports = choicesRight;






//////////////////
// WEBPACK FOOTER
// ./src/exam_parts/choicesRight.js
// module id = 315
// module chunks = 0